import { GET_BLOCKED_USERS } from 'schema-v2/Chat/queries';
import { UNIFIED_GRAPH } from 'utils/constants';

import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { useChatContext } from './ChatProvider';

export const useBlockedUsers = () => {
  const { session } = useChatContext();

  // Fetch blocked users only when Stream session is available (user is created in Stream)
  const { data: blockedUsersData, loading: blockedUsersLoading } = useQuery(GET_BLOCKED_USERS, {
    context: { clientName: UNIFIED_GRAPH },
    skip: !session?.user?.id,
  });

  const blockedUsers = useMemo(() => {
    return blockedUsersData?.blockedConversationUsers?.edges?.map((edge) => edge.node.id) || [];
  }, [blockedUsersData]);

  const isUserBlocked = (userId: string): boolean => {
    return blockedUsers.includes(userId);
  };

  return {
    blockedUsers,
    blockedUsersLoading,
    isUserBlocked,
  };
};
